import React from 'react';
import { RiErrorWarningLine } from "react-icons/ri";
import { useTranslation } from 'react-i18next';
import warningSvg from '../../../../assets/icons/warning.svg';

export const ErrorSpan = ({ children }: { children: string | undefined }) => {
  const { t } = useTranslation();

  // Validation rules are declared at module scope (validation.pattern.ts) and
  // therefore carry an i18n key rather than a sentence. Callers that already
  // have a `t` — the auth forms' server-error branches — pass a finished
  // string; i18next echoes an unknown key back unchanged, so both work here.
  const message = children ? t(children) : children;

  return (
    <p className="text-red-500 text-sm font-body font-normal mb-[22px] ml-[6px] flex items-center">
      <RiErrorWarningLine
        size={15}
        className="inline h-4 w-4 mr-1"
        aria-label={t('common.incorrectField')}
      />
      {message}
    </p>
  );
};
